import { render, staticRenderFns } from "./ConfigImport.vue?vue&type=template&id=7c298cc5&scoped=true"
import script from "./ConfigImport.vue?vue&type=script&lang=js"
export * from "./ConfigImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c298cc5",
  null
  
)

export default component.exports